module.exports = __webpack_public_path__ + "static/media/indorse-logo.cf61346f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/indorse-logo.png
// module id = 560
// module chunks = 146